import BigNumber from 'bignumber.js';
import { BigNumberConstructable, CoinMovability } from '../lib/customType';

export default function checkMovableAvailability(coin: BigNumberConstructable, share: BigNumberConstructable): CoinMovability {
  const hasCoin = new BigNumber(coin).isGreaterThan(0);
  const hasShare = new BigNumber(share).isGreaterThan(0);
  return new CoinMovability(hasCoin, hasShare);
}
